import { render, staticRenderFns } from "./ButtonGroupList.vue?vue&type=template&id=1221d11a&"
import script from "./ButtonGroupList.vue?vue&type=script&lang=js&"
export * from "./ButtonGroupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports